import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCategoriestagssettingssimplifiinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.25,
			cy: 17.25,
			r: 4.25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8,
			height: 8,
			x: 14,
			y: 13.25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M16.248 10.5H8.752a1.25 1.25 0 0 1-1.06-1.912l3.748-6a1.25 1.25 0 0 1 2.12 0l3.748 6a1.25 1.25 0 0 1-1.06 1.912",
			clipRule: "evenodd"
		})
	]
});
export default SvgCategoriestagssettingssimplifiinline;
